import { createSlice } from "@reduxjs/toolkit";
const selectedStoreSlice = createSlice({
  name: "lists",
  initialState: {
    loading: false,
    message: "",
    error: "",
    lists: [],
    list: "",
    activeList: "",
    listItems: [],
    listOrder: {},
    comments: "",
  },
  reducers: {
    setActiveListLoading(state) {
      state.loading = true;
    },
    setActiveListSuccess(state, action) {
      state.activeList = action.payload;
      state.loading = false;
    },
    setActiveListError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setListLoading(state) {
      state.loading = true;
    },
    setListSuccess(state, action) {
      state.list = action.payload;
      state.loading = false;
    },
    setListError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setListItemsLoading(state) {
      state.loading = true;
    },
    setListItemsSuccess(state, action) {
      state.listItems = action.payload;
      state.loading = false;
    },
    setListItemsFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    getActiveListLoading(state) {
      state.loading = true;
    },
    getActiveListSuccess(state) {
      state.list = JSON.parse(JSON.stringify(state.list));
      state.loading = false;
    },
    getActiveListError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setListsLoading(state) {
      state.loading = true;
    },
    setListsSuccess(state, action) {
      state.lists = action.payload;
      state.loading = false;
    },
    setListsError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    addListToStoreLoading: (state) => {
      state.loading = true;
    },
    addListToStoreSuccess: (state, action) => {
      state.loading = false;
      state.lists = [action.payload, ...state.lists];
    },
    addListToStoreFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    renameListLoading: (state) => {
      state.loading = true;
    },
    renameListSuccess: (state, action) => {
      state.loading = false;
      const { listId, newName } = action.payload;
      state.lists = state.lists.map((list) =>
        list.list_id === listId ? { ...list, list: newName } : list
      );
    },
    renameListFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    deleteListLoading: (state) => {
      state.loading = true;
    },
    deleteListSuccess: (state, action) => {
      state.loading = false;
      state.lists = state.lists.filter(
        (list) => list.list_id !== action.payload
      );
    },
    deleteListFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    lockListLoading: (state) => {
      state.loading = true;
    },
    lockListSuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload;
    },
    lockListFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    toggleListLockLoading: (state) => {
      state.loading = true;
    },
    toggleListLockSuccess: (state, action) => {
      state.loading = false;
      const { listId, newLockStatus } = action.payload;
      state.lists = state.lists.map((list) =>
        list.list_id === listId ? { ...list, lock: newLockStatus } : list
      );
    },
    toggleListLockFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    toggleListActivateLoading: (state) => {
      state.loading = true;
    },
    toggleListActivateSuccess: (state, action) => {
      state.loading = false;
      const { listId, status } = action.payload;
      state.lists = state.lists.map((list) =>
        list.list_id === listId ? { ...list, active: status } : list
      );
    },
    toggleListActivateFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    setListOrderPreferenceLoading(state) {
      state.loading = true;
    },
    setListOrderPreferenceSuccess(state, action) {
      state.listOrder = action.payload;
      state.loading = false;
    },
    setListOrderPreferenceFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setPlaceOrderCommentsLoading(state) {
      state.loading = true;
    },
    setPlaceOrderCommentsSuccess(state, action) {
      state.comments = action.payload;
      state.loading = false;
    },
    setPlaceOrderCommentsFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  addListToStoreLoading,
  addListToStoreSuccess,
  addListToStoreFail,
  renameListLoading,
  renameListSuccess,
  renameListFail,
  deleteListLoading,
  deleteListSuccess,
  deleteListFail,
  lockListLoading,
  lockListSuccess,
  lockListFail,
  toggleListLockLoading,
  toggleListLockSuccess,
  toggleListLockFail,
  setListLoading,
  setListSuccess,
  setListError,
  setListItemsLoading,
  setListItemsSuccess,
  setListItemsFail,
  setListsLoading,
  setListsSuccess,
  setListsError,
  toggleListActivateLoading,
  toggleListActivateSuccess,
  toggleListActivateFail,
  setActiveListLoading,
  setActiveListSuccess,
  setActiveListError,
  getActiveListLoading,
  getActiveListSuccess,
  getActiveListError,
  setListOrderPreferenceLoading,
  setListOrderPreferenceSuccess,
  setListOrderPreferenceFail,
  setPlaceOrderCommentsLoading,
  setPlaceOrderCommentsSuccess,
  setPlaceOrderCommentsFail,
} = selectedStoreSlice.actions;
export default selectedStoreSlice.reducer;
